<template>
  <div class="model-select-dia">
    <el-dialog
      title="添加审单人"
      :visible="dialogVisible"
      :close-on-click-modal="false"
      width="800px"
      top="2%"
      @close="close"
    >
      <el-table
        v-if="dialogVisible"
        ref="addCompanyDia"
        :data="dialogTableData"
        v-loading="tableLoading"
        tooltip-effect="dark"
        border
        max-height="515"
        @selection-change="handSelect"
        :row-key="
          (row) => {
            return row.id;
          }
        "
      >
        <el-table-column
          type="selection"
          :reserve-selection="true"
          align="center"
        >
        </el-table-column>
        <el-table-column type="index" align="center" label="序号" width="50" />
        <el-table-column label="人员姓名" align="center">
          <template slot-scope="{ row }">
            <el-tooltip
              class="item"
              effect="dark"
              :content="row.staffName"
              placement="top"
            >
              <div class="nowrap-ellipsis">
                {{ row.staffName }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="人员姓名" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.mobile }}</span>
          </template>
        </el-table-column>
        <el-table-column label="角色" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.isMajor?'创建人':row.staffType=='01'?'子账号':row.staffType=='02'?'总监':row.staffType=='03'?'店长':'店员' }}</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="close">取消</el-button>
        <el-button type="primary" @click.native="addCompanySubmit"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _api from "@/utils/request";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    auditIds: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      expenseDeductionList: [], //扣费项列表
      dialogTableData: [],
      tableLoading: false, //左侧表格loading
      selectedCompanyList: [],
    };
  },
  created() {
    this.dialogSearchCompany();
  },
  methods: {
    close() {
      this.selectedCompanyList = [];
      this.$emit("close");
    },
    dialogSearchCompany() {
      this.tableLoading = true;
      _api.getBlacklistAuditStaffList({
          auditIds: this.auditIds,
          type: "01",
        })
        .then((res) => {
          this.dialogTableData = res.data;
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    handSelect(selection, row) {
      this.selectedCompanyList = selection;
    },
    // 添加确认弹框
    addCompanySubmit() {
      if (!this.selectedCompanyList.length) {
        this.$message.error("请先审单人");
        return;
      }
      this.$emit("addCompanySubmit",this.selectedCompanyList)
    },
  },
};
</script>

<style lang="scss" scoped>
.nowrap-ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
</style>
